<br />
<div style="text-align: center;">

    <h1>Historial cuotas</h1>
</div>
<br />



<div class="container principal" id="tabla" style="background-color: white; padding-top: 10px; padding-bottom:50px;">

    <div class="container principal">
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-4">
                    <h2>Afiliado:</h2>
                </div>

                <div class="col-lg-8">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>

                </div>

            </div>

        </div>
        <div *ngIf="rol != 'ROLE_AFILIADO'">

            <div class="row line">

                <div class="col-lg-2"> </div>

                <div class="col-lg-2">
                    <h2> Rut Afiliado </h2>
                </div>

                <div class="col-lg-4">

                    <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado" #rutAfiliado="ngModel"
                        class="form-control" type="text" required
                        placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                        pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-4">

                    <button class="btn btn-primary" id="btnBuscarAfiliado" name="btnBuscarAfiliado"
                        (click)="buscaAfiliado(this.rutAfiliado.value)">

                        Buscar

                    </button>

                </div>
            </div>
            <div class="row line">

                <div class="col-lg-4"> </div>
                <div class="col-lg-5">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>
                </div>
            </div>
        </div>

    </div>
    <br />


    <div class="row line">
        <div class="col-lg-1"> </div>
        <div class="col-lg-3">
            <h2>Historial</h2>
        </div>

    </div>
    <div class="table-responsive">

        <table class="table" id="tablaPlan" name="tablaPlan">

            <thead style="background-color: #0f69b4;color:white;">
                <tr>
                    <th style="text-align: left;">Id</th>
                    <th style="text-align: left;">Nombre Afiliado</th>
                    <th style="text-align: left;">Mes</th>
                    <th style="text-align: left;">Año</th>
                    <th style="text-align: left;">Fecha Modificación</th>
                    <th style="text-align: left;">Monto</th>
                    <th style="text-align: left;">Estado</th>
                    <th style="text-align: left; width: 100px;">Tipo Rechazo</th>
                    <th style="text-align: left; width: 100px;">Comentario Rechazo</th>
                    <th style="text-align: left;">Acción</th>
                    <th style="text-align: left;" *ngIf="(rol == 'ROLE_ADMINISTRADOR')">Anular/Reversar</th>
                </tr>
            </thead>
            <tbody>
                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                    *ngFor="let cuota of this.afiliadoCuota | paginate: config; let i = index">
                    <td style="text-align: left;">{{cuota.id}}</td>
                    <td style="text-align: left;">{{cuota.nombreUsuario}}</td>
                    <td style="text-align: left;">{{cuota.fechaCuota.split('-')[1]}}</td>
                    <td style="text-align: left;">{{cuota.fechaCuota.split('-')[2]}}</td>
                    <td style="text-align: left;">{{cuota.fechaModificacion}}</td>
                    <td style="text-align: left;">{{cuota.monto}}</td>

                    <td style="text-align: left;" *ngIf="cuota.estado != 'VIGENTE'"> <a (click)="openDialogValidarPago(cuota.id)" style="cursor:pointer; text-decoration: underline;">{{cuota.estado}} </a></td>
                    <td style="text-align: left;" *ngIf="cuota.estado == 'VIGENTE'"> {{cuota.estado}}</td>


                    <td style="text-align: left; width: 100px;"><a (click)="detalleRechazoBeneficiario(cuota.id)"
                            style="cursor:pointer; text-decoration: underline;">{{cuota.nombreMotivoRechazo|slice:0:8}}
                        </a> <a *ngIf="cuota.estado=='RECHAZADA'">..</a> </td>
                    <td style="text-align: left; width: 100px;"><a (click)="detalleRechazoBeneficiario(cuota.id)"
                            style="cursor:pointer; text-decoration: underline;">{{cuota.motivoRechazo|slice:0:8}}</a>
                        <a *ngIf="cuota.estado=='RECHAZADA'">..</a>
                    </td>
                    <th style="text-align: left">
                        <!-- 
                        <div *ngIf="cuota.estado=='VIGENTE'">
                            <button class="btn btn-primary" id="btnPagar" 
                            (click)="pagarDeuda(cuota.id,cuota.numCuota,true,i,cuota.estadoPrevio)
                            (click)="pagarDeuda(cuota.id)">Pagar</button>
                             </button> (click)="pagarDeuda(cuota.id,cuota.numCuota,true,i,cuota.estadoPrevio)
                        </div>
                        -->
                        <div *ngIf="cuota.estado=='VIGENTE'">
                            <button class="btn btn-primary" id="btnPagar" (click)="pagarDeuda(cuota.id)">Pagar</button>

                        </div>
                    </th>
                    <th style="text-align: center"
                        *ngIf="( rol == 'ROLE_ADMINISTRADOR' && (cuota.estado!='RECHAZADA' && cuota.estado!='ANULADA REVERSADA'))">
                        <button class="btn btn-secondary" id="btnAnular" name="btnAnular"
                            (click)="anularCuota(cuota.id)">Anular/Reversa</button>
                    </th>

                </tr>
            </tbody>
        </table>
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">
            <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente"
                (pageChange)="pageChanged($event,this.afiliado.rutAfiliado)" autoHide="true"> </pagination-controls>
        </div>
        <div *ngIf="rol != 'ROLE_AFILIADO'">
            <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente"
                (pageChange)="pageChanged($event,buscador.rutAfiliado)" autoHide="true"> </pagination-controls>
        </div>
    </div>
    <br>

    <br />





</div>





<br /><br /><br />